<template>
    <div class="main-container" ref="mainContainer">
        <div class="main-table">
            <div class="search-form-box">
                <SearchForm :searchItems="searchItems" :showMoreBtn="false" v-on:refresh="refresh" ref="search"/>
            </div>
            <div class="button-group">
                <el-button icon="el-icon-plus" size="small" type="primary" @click="addData">新增</el-button>
                <el-button icon="el-icon-delete" size="small" @click="deleteData">删除</el-button>
            </div>
            <div class="main-table-list">
                <List :height="tableHeight" :isIndex="true" :isSelection="true" :columns="tableCols" :data="tableData" stripe ref="list" :operates="operates" v-on:handleSelect="handleSelect"/>
            </div>
            <div class="main-pagination">
                <Pagination :data="pagination" @refresh="pageData" ref="pagination" />
            </div>
        </div>
        <AddPlatfrom ref="addPlatfrom" v-on:refreshData="refreshData"/>
    </div>
</template>
<script>
import SearchForm from '@/components/form/searchForm'
import Pagination from '@/components/pagination/default'
import { Notification } from 'element-ui'
import {platformCompanyApi} from '@/api/managementSystemApi'
import List from '@/components/list/default'
import AddPlatfrom from './addPlatfrom'
export default {
  name: 'land',
  components: {
    SearchForm,
    Pagination,
    List,
    AddPlatfrom
  },
  data () {
    return {
      tableCols: [
        { label: '单位名称', prop: 'companyname' }
      ],
      searchItems: [
        { label: '公司名称', type: 'text', prop: 'companyname' }
      ],
      searchParams: [],
      operates: {
        width: 250,
        list: [{
          id: '1',
          label: '修改',
          type: 'text',
          show: true,
          disabled: false,
          size: 'small',
          method: (index, row) => {
            this.handlCheck(row)
          }
        }, {
          id: '1',
          label: '删除',
          type: 'text',
          show: true,
          disabled: false,
          size: 'small',
          method: (index, row) => {
            this.$confirm('此操作将永久删除该单位, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // 删除的逻辑
              this.deleteItLand(row)
            })
          }
        }]
      },
      pagination: { pageSize: 10, pageNum: 1, total: 0 }, // 分页数据
      tableData: [],
      rowData: {},
      rowsData: {},
      tableHeight: 0,
      pageLength: 10,
      pageNum: 1,
      pageTotal: 0,
      title: '',
      otherTitle: ''
    }
  },
  watch: {
    tableHeight (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.tableHeight = this.$refs.mainContainer.offsetHeight - 205
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = this.$refs.mainContainer.offsetHeight - 205
    })
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.queryData()
    },
    queryData(pageNumber, pageLength, pageTotal, title, otherTitle) {
      const _this = this
      const searchParams = this.searchParams
      let companyname = ''
      if (searchParams.length == 0) {

      } else {
        companyname = searchParams[0].val
      }
      let pageNo = 0
      let pageSize = 0
      let total = 0
      if (title == '删除' || otherTitle == '编辑保存') {
        if (pageNumber) {
          pageNo = pageNumber
        }
        if (pageLength) {
          pageSize = pageLength
        }
        if (pageTotal) {
          total = pageTotal
        }
      } else {
        if (pageNumber) {
          pageNo = 1
        }
        if (pageLength) {
          pageSize = pageLength
        }
        if (pageTotal) {
          total = pageTotal
        }
      }
      const params = {
        pageNo,
        pageSize,
        total,
        params: [
          {
            column: 'companyname',
            type: 'LIKE',
            val: companyname
          },
          {
            column: 'create_time',
            type: 'ORDERBY',
            val: 'desc'
          },
          {
            column: 'id',
            type: 'ORDERBY',
            val: 'desc'
          }
        ]
      }
      platformCompanyApi.selectByPage(params).then(response => {
        if (response.code === '200') {
          this.tableData = []
          const list = response.data.list
          if (list.length < this.pageLength) {
            this.tableData = list
          } else {
            for (let i = 0; i < this.pageLength; i++) {
              this.tableData.push(list[i])
            }
          }
          this.pagination.total = response.data.total
          if (this.title == '删除' || this.otherTitle == '编辑保存') {
            this.pagination.pageNum = this.pageNum
            this.title = ''
            this.otherTitle = ''
          } else {
            this.pagination.pageNum = 1
          }
        } else {
          Notification.warning({
            title: '警告',
            message: '获取数据出错!',
            type: 'warning'
          })
          this.tableData = []
          this.pagination.total = 0
        }
      })
    },
    pageData(data) {
      const searchParams = this.searchParams
      let companyname = ''
      if (searchParams.length == 0) {

      } else {
        companyname = searchParams[0].val
      }
      const params = {
        pageNo: data.pagination.pageNum,
        pageSize: data.pagination.pageSize,
        total: this.pagination.total,
        params: [
          {
            column: 'companyname',
            type: 'LIKE',
            val: companyname
          },
          {
            column: 'create_time',
            type: 'ORDERBY',
            val: 'desc'
          },
          {
            column: 'id',
            type: 'ORDERBY',
            val: 'desc'
          }
        ]
      }
      this.pageLength = data.pagination.pageSize
      this.pageNum = data.pagination.pageNum
      this.pageTotal = this.pagination.total
      platformCompanyApi.selectByPage(params).then(response => {
        if (response.code === '200') {
          this.tableData = []
          const list = response.data.list
          this.tableData = list
        } else {
          Notification.warning({
            title: '警告',
            message: '获取数据出错!',
            type: 'warning'
          })
          this.pagination.total = 0
        }
      })
    },
    handlCheck (row) {
      this.rowData = row
      this.rowData = JSON.stringify(this.rowData)
      this.editData = JSON.parse(this.rowData)
      this.otherTitle = '编辑保存'
      this.$refs.addPlatfrom.open(row.id, this.editData)
    },
    deleteItLand (row) {
      if (row) {
        const id = row.id
        const params = {
          id
        }
        platformCompanyApi.deletePlatformComPanyID(params).then(response => {
          if (response.code === '200') {
            this.$utils.success('删除成功！')
            this.title = '删除'
            this.queryData(this.pageNum, this.pageLength, this.pageTotal, this.title)
          } else {
            this.$utils.error('删除失败！')
          }
        })
      }
    },
    refresh (data) {
      if (data.searchParams) {
        let companyname = ''
        this.searchParams = data.searchParams
        if (data.searchParams.length == 0) {

        } else {
          companyname = data.searchParams[0].val
        }
        const params = {
          pageNo: 1,
          pageSize: this.pageLength,
          params: [
            {
              column: 'companyname',
              type: 'LIKE',
              val: companyname
            },
            {
              column: 'create_time',
              type: 'ORDERBY',
              val: 'desc'
            },
            {
              column: 'id',
              type: 'ORDERBY',
              val: 'desc'
            }
          ]
        }
        this.pageNum = 1
        platformCompanyApi.selectByPage(params).then(response => {
          if (response.code === '200') {
            if (response.data.length == 0) {
              this.tableData = []
              this.pagination.total = 0
              Notification.warning({
                title: '提示',
                message: '暂未查到数据!',
                type: 'warning'
              })
            } else {
              this.tableData = []
              const list = response.data.list
              this.tableData = list
              this.pagination.total = response.data.total
              this.pagination.pageNum = 1
            }
          } else {
            Notification.warning({
              title: '警告',
              message: '获取数据出错!',
              type: 'warning'
            })
            this.tableData = []
            this.pagination.total = 0
          }
        })
      }
    },
    addData() {
      this.searchParams = []
      this.otherTitle = '新增保存'
      this.$refs.addPlatfrom.open(0)
    },
    handleSelect (row) {
      this.rowsData = row
    },
    // 刷新
    refreshData () {
      this.queryData(this.pageNum, this.pageLength, this.pageTotal, this.title, this.otherTitle)
    },
    deleteData() {
      const row = this.rowsData
      if (row.length > 0) {
        this.$confirm('此操作将永久删除该单位, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 删除的逻辑
          const lndMatchingArr = []
          for (let j = 0; j < row.length; j++) {
            lndMatchingArr.push(row[j].id)
          }
          if (lndMatchingArr.length > 0) {
            const params = {
              tPlatformcompanyIds: lndMatchingArr
            }
            platformCompanyApi.batchDeletePlatformComPany(params).then(response => {
              if (response.code === '200') {
                this.$utils.success('删除成功！')
                this.rowsData = {}
                this.title = '删除'
                this.queryData(this.pageNum, this.pageLength, this.pageTotal, this.title)
              } else {
                this.$utils.error('删除失败！')
              }
            })
          }
        })
      } else {
        this.$utils.warning('请勾选需要删除的数据!')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    @import "@/scss/list.scss";
</style>
